module.exports = __webpack_public_path__ + "static/media/amazon.38d22457.svg";